import React, { useEffect, useState } from "react";

// The HTTP Date header is supplied by Hosting, independently of the user's clock.
export default function ServerCopyright({ template }) {
  const [year, setYear] = useState(null);

  useEffect(() => {
    let disposed = false;
    let timer;
    let request;

    const refresh = async () => {
      if (request || disposed) return;
      clearTimeout(timer);
      request = new AbortController();
      const timeout = setTimeout(() => request && request.abort(), 10000);
      let nextRefresh = 60000;
      try {
        const response = await fetch(`/version.json?server-time=${Math.random().toString(36).slice(2)}`, {
          method: "HEAD",
          cache: "no-store",
          signal: request.signal,
        });
        const dateHeader = response.headers.get("Date");
        const serverTime = dateHeader ? Date.parse(dateHeader) : NaN;
        if (!response.ok || !Number.isFinite(serverTime)) throw new Error("Server date unavailable");
        const serverYear = new Date(serverTime).getUTCFullYear();
        if (!disposed) setYear(serverYear);
        // Refresh hourly, or just after the server's UTC year changes.
        nextRefresh = Math.min(3600000, Date.UTC(serverYear + 1, 0, 1) - serverTime + 1000);
      } catch (_) {
        // Keep the last confirmed year. Never substitute the browser's clock.
      } finally {
        clearTimeout(timeout);
        request = null;
        if (!disposed) timer = setTimeout(refresh, nextRefresh);
      }
    };

    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    refresh();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      disposed = true;
      clearTimeout(timer);
      if (request) request.abort();
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return <span>{template.replace("{year}", year === null ? "" : String(year))}</span>;
}
